import { render, staticRenderFns } from "./CalendarOrder.vue?vue&type=template&id=4f5f460f&scoped=true"
import script from "./CalendarOrder.vue?vue&type=script&lang=js"
export * from "./CalendarOrder.vue?vue&type=script&lang=js"
import style0 from "./CalendarOrder.vue?vue&type=style&index=0&id=4f5f460f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5f460f",
  null
  
)

export default component.exports